import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Alejandro',
  city: 'Córdoba',
  time: '1 minuto'
}, {
  name: 'María',
  city: 'Buenos Aires',
  time: '3 minutos'
}, {
  name: 'Lucas',
  city: 'Rosario',
  time: '5 minutos'
}, {
  name: 'Valentina',
  city: 'Mendoza',
  time: '7 minutos'
}, {
  name: 'Martín',
  city: 'La Plata',
  time: '9 minutos'
}, {
  name: 'Carolina',
  city: 'Tucumán',
  time: '12 minutos'
}, {
  name: 'Diego',
  city: 'Mar del Plata',
  time: '14 minutos'
}, {
  name: 'Florencia',
  city: 'Salta',
  time: '18 minutos'
}, {
  name: 'Nicolás',
  city: 'Santa Fe',
  time: '22 minutos'
}, {
  name: 'Julieta',
  city: 'Neuquén',
  time: '25 minutos'
}, {
  name: 'Sofía',
  city: 'Bahía Blanca',
  time: '28 minutos'
}, {
  name: 'Federico',
  city: 'San Juan',
  time: '32 minutos'
}, {
  name: 'Camila',
  city: 'Posadas',
  time: '35 minutos'
}, {
  name: 'Gonzalo',
  city: 'Resistencia',
  time: '40 minutos'
}];
export function SocialProofNotification() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Show first notification after 5 seconds
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide after 4 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
    // Show next one after 8 seconds (4s visible + 4s hidden)
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setIsVisible(true);
    }, 8000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [isVisible, currentIndex]);
  const current = purchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-40" data-id="element-254">
      <AnimatePresence data-id="element-255">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 20,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 10,
        x: -10
      }} transition={{
        duration: 0.4
      }} className="bg-white rounded-xl shadow-xl border border-slate-200 p-4 flex items-center gap-3 max-w-xs" data-id="element-256">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-257">
              <ShoppingBag size={20} className="text-green-600" data-id="element-258" />
            </div>
            <div className="text-left" data-id="element-259">
              <p className="text-sm font-bold text-slate-900" data-id="element-260">
                {current.name} compró
              </p>
              <p className="text-xs text-slate-500" data-id="element-261">
                hace {current.time} desde {current.city}
              </p>
            </div>
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse flex-shrink-0" data-id="element-262"></div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}